/* eslint-disable */
import React from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';
import './styles/styles.css';

const collegeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Student Storage Bay Area',
    description:
      'Valet storage for college students at UC Berkeley, UCSF, SF State, and USF. Free pickup from dorms and apartments. Store during summer break starting at $30/month.',
    provider: {
      '@type': 'LocalBusiness',
      name: 'Bins Storage',
      url: 'https://bins-storage.com',
    },
    areaServed: ['Berkeley', 'San Francisco', 'Bay Area'],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Does Bins Storage offer student storage at UC Berkeley?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes. Bins serves both on-campus and off-campus addresses at UC Berkeley. We pick up from your dorm room or apartment and store your items until you need them back.',
        },
      },
      {
        '@type': 'Question',
        name: 'How much does summer storage cost for college students?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Summer storage starts at $30/month for a 5x5 unit, with free pickup included. A 5x10 unit is $50/month and fits a full apartment\'s worth of furniture and boxes.',
        },
      },
      {
        '@type': 'Question',
        name: 'Do I need a car to use Bins Storage as a student?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'No. Bins picks up from your door and delivers back to your door. No truck, no car, no trips to a storage facility required.',
        },
      },
    ],
  },
];

// ─── styles ───────────────────────────────────────────────────────────────────

const heroStyle = {
  backgroundColor: '#261136',
  padding: '4rem 2rem 3rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
};

const heroHeadingStyle = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: 'clamp(2rem, 5vw, 3.25rem)',
  fontWeight: 700,
  color: '#FFF',
  margin: '0 0 1rem',
};

const heroSubStyle = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '1.15rem',
  color: 'rgba(255,255,255,0.82)',
  maxWidth: 600,
  lineHeight: 1.65,
  margin: '0 0 0.75rem',
};

const schoolBadgesRow = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.6rem',
  justifyContent: 'center',
  margin: '1.5rem 0 2rem',
};

const schoolBadge = {
  backgroundColor: 'rgba(255,255,255,0.12)',
  color: '#FFF',
  fontFamily: 'Raleway, sans-serif',
  fontWeight: 600,
  fontSize: '0.85rem',
  padding: '6px 14px',
  borderRadius: 999,
  border: '1px solid rgba(255,255,255,0.2)',
};

const ctaButton = {
  display: 'inline-block',
  backgroundColor: '#7B1FA2',
  color: '#FFF',
  fontFamily: 'Raleway, sans-serif',
  fontWeight: 700,
  fontSize: '1.1rem',
  padding: '14px 32px',
  borderRadius: 999,
  textDecoration: 'none',
  border: '2px solid rgba(255,255,255,0.3)',
};

const whiteSection = {
  backgroundColor: '#FFF',
  padding: '3.5rem 2rem',
};

const innerMax = {
  maxWidth: 860,
  margin: '0 auto',
};

const sectionHeadingStyle = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '2rem',
  fontWeight: 700,
  color: '#261136',
  marginBottom: '0.5rem',
  textAlign: 'center',
};

const sectionSubStyle = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '1.05rem',
  color: '#555',
  textAlign: 'center',
  maxWidth: 620,
  margin: '0 auto 2.5rem',
  lineHeight: 1.65,
};

const reasonsGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
  gap: '1.25rem',
};

const reasonCard = {
  backgroundColor: '#F9F6FC',
  borderRadius: 12,
  padding: '1.5rem',
};

const reasonTitle = {
  fontFamily: 'Raleway, sans-serif',
  fontWeight: 700,
  fontSize: '1.05rem',
  color: '#7B1FA2',
  marginBottom: '0.4rem',
};

const reasonBody = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '0.95rem',
  color: '#555',
  lineHeight: 1.6,
};

const summerSection = {
  backgroundColor: '#7B1FA2',
  padding: '3.5rem 2rem',
  textAlign: 'center',
};

const summerHeading = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '2rem',
  fontWeight: 700,
  color: '#FFF',
  marginBottom: '0.75rem',
};

const summerBody = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '1.05rem',
  color: 'rgba(255,255,255,0.88)',
  maxWidth: 640,
  margin: '0 auto 1.5rem',
  lineHeight: 1.65,
};

const timelineStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1rem',
  justifyContent: 'center',
  maxWidth: 800,
  margin: '2rem auto 0',
};

const timelineStep = {
  background: 'rgba(255,255,255,0.1)',
  border: '1px solid rgba(255,255,255,0.2)',
  borderRadius: 12,
  padding: '1.25rem 1.5rem',
  flex: '1 1 180px',
  maxWidth: 220,
  textAlign: 'left',
};

const timelineLabel = {
  fontFamily: 'Raleway, sans-serif',
  fontWeight: 700,
  fontSize: '0.8rem',
  color: '#D9B8F5',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  marginBottom: 6,
};

const timelineText = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '0.95rem',
  color: '#FFF',
  lineHeight: 1.55,
};

const pricingSection = {
  backgroundColor: '#261136',
  padding: '3.5rem 2rem',
  textAlign: 'center',
};

const pricingGrid = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1.5rem',
  justifyContent: 'center',
  maxWidth: 700,
  margin: '0 auto 2rem',
};

const pricingCard = {
  background: 'radial-gradient(circle at top, #3A1F52 0, #170824 60%, #12061f 100%)',
  borderRadius: 16,
  padding: '2rem 1.75rem',
  border: '1px solid rgba(255,255,255,0.1)',
  color: '#F5F5FA',
  flex: '1 1 240px',
  maxWidth: 300,
  textAlign: 'left',
};

const pricingLabel = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '0.85rem',
  color: '#AAB5E0',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  marginBottom: 8,
};

const pricingPrice = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '2.25rem',
  fontWeight: 800,
  color: '#FFF',
  marginBottom: 4,
};

const pricingDesc = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '0.9rem',
  color: '#AAB5E0',
  lineHeight: 1.6,
};

const pricingCta = {
  display: 'inline-block',
  backgroundColor: '#7B1FA2',
  color: '#FFF',
  fontFamily: 'Raleway, sans-serif',
  fontWeight: 700,
  fontSize: '1rem',
  padding: '12px 28px',
  borderRadius: 999,
  textDecoration: 'none',
  border: '2px solid rgba(255,255,255,0.3)',
};

const faqSection = {
  padding: '3.5rem 2rem',
  maxWidth: 720,
  margin: '0 auto',
};

const faqItem = {
  borderBottom: '1px solid #EEE',
  paddingBottom: '1.25rem',
  marginBottom: '1.25rem',
};

const faqQuestion = {
  fontFamily: 'Raleway, sans-serif',
  fontWeight: 700,
  fontSize: '1.05rem',
  color: '#261136',
  marginBottom: '0.4rem',
};

const faqAnswer = {
  fontFamily: 'Raleway, sans-serif',
  fontSize: '0.97rem',
  color: '#555',
  lineHeight: 1.65,
};

const crossLinkBanner = {
  backgroundColor: '#F9F6FC',
  padding: '2.5rem 2rem',
  textAlign: 'center',
  borderTop: '1px solid #EDE0F7',
};

const crossLinkCta = {
  display: 'inline-block',
  backgroundColor: '#7B1FA2',
  color: '#FFF',
  fontFamily: 'Raleway, sans-serif',
  fontWeight: 700,
  fontSize: '1rem',
  padding: '11px 26px',
  borderRadius: 999,
  textDecoration: 'none',
  marginTop: '0.75rem',
};

// ─── component ────────────────────────────────────────────────────────────────

const CollegeStorage = () => (
  <>
    <SEO
      title="Student Storage Berkeley & Bay Area | UC Berkeley Summer Storage | Bins"
      description="Valet storage for UC Berkeley, UCSF, SF State, and USF students. Free pickup from your dorm or apartment. Summer break storage starting at $30/month — no truck needed."
      path="/college-storage"
      schema={collegeSchema}
    />

    {/* HERO */}
    <section style={heroStyle}>
      <h1 style={heroHeadingStyle}>
        Student Storage in the Bay Area
      </h1>
      <p style={heroSubStyle}>
        End of semester? Moving out for summer? We pick up from your dorm or apartment,
        store your stuff, and deliver it back whenever you're ready — starting at $30/month
        with free pickup.
      </p>
      <div style={schoolBadgesRow}>
        {['UC Berkeley', 'UCSF', 'SF State', 'USF', 'Berkeley City College'].map((s) => (
          <span key={s} style={schoolBadge}>{s}</span>
        ))}
      </div>
      <a href="/Download" style={ctaButton}>Reserve Storage Now</a>
      <p style={{ fontFamily: 'Raleway, sans-serif', fontSize: '0.85rem', color: 'rgba(255,255,255,0.6)', marginTop: '0.75rem' }}>
        Free initial pickup · No truck needed · Cancel anytime
      </p>
    </section>

    {/* WHY VALET FOR STUDENTS */}
    <section style={whiteSection}>
      <div style={innerMax}>
        <h2 style={sectionHeadingStyle}>Why Students Choose Valet Storage</h2>
        <p style={sectionSubStyle}>
          Traditional self storage was designed for people with cars and free afternoons.
          Valet storage is built for students.
        </p>
        <div style={reasonsGrid}>
          {[
            {
              title: 'No car? No problem.',
              body: 'We come to you. No truck rental, no rideshare with a couch, no asking friends for favors. A driver picks up from your dorm room or off-campus apartment.',
            },
            {
              title: 'Free pickup included.',
              body: 'Your first pickup is free with every plan. Move-out day is already stressful enough — we handle the hauling.',
            },
            {
              title: 'See your stuff anytime.',
              body: 'The Bins app keeps a photo inventory of everything in storage. When you need something back, just tap and schedule a delivery.',
            },
            {
              title: '$30/month — cheaper than self storage.',
              body: 'Self storage in the Bay Area runs $85–$120/month before truck rentals and movers. Bins starts at $30/month with pickup included.',
            },
            {
              title: 'On-campus and off-campus pickup.',
              body: 'We serve dorms, co-ops, and apartments throughout Berkeley and the surrounding Bay Area. Just give us your address.',
            },
            {
              title: 'Flexible scheduling.',
              body: 'Moving out in May and back in August? Store for the whole summer. Need to extend? Easy. No rigid contracts.',
            },
          ].map(({ title, body }) => (
            <div key={title} style={reasonCard}>
              <div style={reasonTitle}>{title}</div>
              <div style={reasonBody}>{body}</div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* SUMMER STORAGE TIMELINE */}
    <section style={summerSection}>
      <h2 style={summerHeading}>Summer Break Storage — How It Works</h2>
      <p style={summerBody}>
        The typical UC Berkeley student moves out in May and back in August. Here's how
        most students use Bins for summer storage.
      </p>
      <div style={timelineStyle}>
        {[
          { label: 'April–May', text: 'Reserve your unit online. Lock in your pickup date for move-out week.' },
          { label: 'Move-out day', text: 'Pack your boxes and bins. We pick up from your dorm or apartment — free.' },
          { label: 'All summer', text: 'Your items are stored securely. Browse your inventory in the app anytime.' },
          { label: 'August', text: 'Schedule delivery to your new address. We will bring everything back to your door.' },
        ].map(({ label, text }) => (
          <div key={label} style={timelineStep}>
            <div style={timelineLabel}>{label}</div>
            <div style={timelineText}>{text}</div>
          </div>
        ))}
      </div>
    </section>

    {/* WHAT YOU CAN STORE */}
    <section style={whiteSection}>
      <div style={innerMax}>
        <h2 style={sectionHeadingStyle}>What Can You Store?</h2>
        <p style={sectionSubStyle}>
          Pretty much anything from a dorm room or apartment. Here's what students typically store with Bins.
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.6rem', justifyContent: 'center' }}>
          {[
            'Boxes & bins', 'Clothes & bedding', 'Mini fridge', 'Desk & chair',
            'Bed frame & mattress', 'Bookshelves', 'Luggage', 'Bikes',
            'Sports equipment', 'Kitchen items', 'TV & electronics', 'Lamps & decor',
          ].map((item) => (
            <span key={item} style={{ backgroundColor: '#F9F6FC', color: '#5B1F8A', fontFamily: 'Raleway, sans-serif', fontWeight: 600, fontSize: '0.9rem', padding: '7px 16px', borderRadius: 999, border: '1px solid #EDE0F7' }}>
              {item}
            </span>
          ))}
        </div>
      </div>
    </section>

    {/* PRICING */}
    <section style={pricingSection}>
      <h2 style={{ fontFamily: 'Raleway, sans-serif', fontSize: '2rem', fontWeight: 700, color: '#FFF', marginBottom: '0.5rem' }}>
        Student-Friendly Pricing
      </h2>
      <p style={{ fontFamily: 'Raleway, sans-serif', fontSize: '1.05rem', color: '#AAB5E0', marginBottom: '2rem', textAlign: 'center' }}>
        Free initial pickup with every plan. No surprise fees.
      </p>
      <div style={pricingGrid}>
        <div style={pricingCard}>
          <div style={pricingLabel}>5×5 Unit — Small Closet</div>
          <div style={pricingPrice}>$30<span style={{ fontSize: '1rem', fontWeight: 400, color: '#AAB5E0' }}>/mo</span></div>
          <div style={pricingDesc}>
            Dorm essentials, seasonal clothes, boxes, luggage, small appliances. Perfect
            for a single dorm room move-out.
          </div>
        </div>
        <div style={pricingCard}>
          <div style={pricingLabel}>5×10 Unit — Large Closet</div>
          <div style={pricingPrice}>$50<span style={{ fontSize: '1rem', fontWeight: 400, color: '#AAB5E0' }}>/mo</span></div>
          <div style={pricingDesc}>
            Full apartment storage — desk, bed frame, dresser, boxes, furniture. Ideal
            for a 1-bedroom or shared apartment move-out.
          </div>
        </div>
      </div>
      <a href="/Download" style={pricingCta}>Reserve Your Unit</a>
    </section>

    {/* FAQ */}
    <section style={faqSection}>
      <h2 style={{ fontFamily: 'Raleway, sans-serif', fontSize: '2rem', fontWeight: 700, color: '#261136', marginBottom: '1.75rem' }}>
        Student Storage FAQ
      </h2>
      {[
        {
          q: 'Do you pick up from UC Berkeley dorms?',
          a: "Yes — we serve both on-campus dorms and off-campus apartments. Just schedule your pickup online and give us your address. We'll handle the rest.",
        },
        {
          q: 'Can I store for just the summer?',
          a: 'Absolutely. Most students store from May through August. There\'s no long-term contract required — store for as long as you need and cancel when you\'re done.',
        },
        {
          q: 'How do I get my items back in August?',
          a: 'Open the Bins app, select the items you want back, and schedule a delivery to your new address. You can deliver to a different address than your pickup location.',
        },
        {
          q: 'Do you serve UCSF, SF State, and USF students?',
          a: 'Yes. We serve students across the Bay Area including UCSF (Mission Bay and Parnassus), SF State (near Lake Merced), and USF (the Panhandle / Lone Mountain area).',
        },
        {
          q: 'What if I need to access something mid-summer?',
          a: 'Just schedule a delivery through the app. Deliveries typically require 48 hours notice. You can also request specific items rather than your entire unit.',
        },
        {
          q: 'Is there a student discount?',
          a: 'Our standard pricing — $30/month with free pickup — is already well below market rate. A comparable 5×5 self-storage unit in Berkeley typically costs $85–$100/month before truck rentals.',
        },
      ].map(({ q, a }) => (
        <div key={q} style={faqItem}>
          <div style={faqQuestion}>{q}</div>
          <div style={faqAnswer}>{a}</div>
        </div>
      ))}
    </section>

    {/* CROSS-LINK to Berkeley page */}
    <section style={crossLinkBanner}>
      <p style={{ fontFamily: 'Raleway, sans-serif', fontSize: '1.1rem', color: '#261136', margin: 0, textAlign: 'center' }}>
        Looking for storage options across all of Berkeley and the East Bay?
      </p>
      <Link to="/berkeley" style={crossLinkCta}>
        See Berkeley Valet Storage →
      </Link>
    </section>
  </>
);

export default CollegeStorage;
